import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  MenuItem,
  Chip,
  Select,
  InputLabel,
  FormControl,
  Switch,
  FormControlLabel,
  Grid,
  TextField
} from "@material-ui/core";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker
} from "@material-ui/pickers";
import "./upsell.css";
import DateFnsUtils from "@date-io/date-fns";
import movieEntryApi from "../../../api/movie-entry-api";
import concessionsApi from "../../../api/concessions-api";
import emptyConcessions from "../../../assets/images/empty-concessions.png";
import cinemasApi from "../../../api/cinemas";
import { CircularLoad } from "../../../components/Loader";

const UpsellModal = ({
  open,
  onClose,
  onConfirm,
  upsellMode,
  jwt,
  upsellToEdit
}) => {
  const [selectedMovie, setSelectedMovie] = useState();
  const [selectedConcessions, setSelectedConcessions] = useState([]);
  const [smartRecommendation, setSmartRecommendation] = useState(false);
  const [defineManually, setDefineManually] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    isError: false,
    message: ""
  });

  const [cinemasLoading, setCinemasLoading] = useState(false);
  const [selectedState, setSelectedState] = useState({});
  const [selectedCinema, setSelectedCinema] = useState({});
  const [states, setStates] = useState([]);

  const [moviesData, setMoviesData] = useState([]);
  const [concessionsData, setConcessionsData] = useState([]);

  const handleChangeMovie = event => {
    setSelectedMovie(event.target.value);
  };

  const handleChangeConcessions = event => {
    setSelectedConcessions(event.target.value);
  };

  const handleUpdate = () => {
    const concession_ids = selectedConcessions;
    const rosetta_movie_id = selectedMovie;
    const cinema_id = selectedCinema.id;

    const data = {
      rosetta_movie_id,
      cinema_id,
      suggestion_mode: defineManually ? "MANUAL" : "ALGORITHM",
      start_date: startDate ? startDate : "",
      start_time: startTime ? startTime.toTimeString().slice(0, 8) : "",
      end_date: endDate ? endDate : "",
      end_time: endTime ? endTime.toTimeString().slice(0, 8) : "",
      concession_ids: concession_ids,
      id: upsellToEdit.id
    };
    onConfirm(data.id, data, null);
  };

  const handleCreate = () => {
    const concession_ids = selectedConcessions;
    const rosetta_movie_id = selectedMovie;
    const cinema_id = selectedCinema.id;

    if (defineManually) {
      const data = {
        cinema_id,
        rosetta_movie_id,
        concession_ids,
        suggestion_mode: "MANUAL",
        start_date: startDate ? startDate : "",
        start_time: startTime ? startTime.toTimeString().slice(0, 8) : "",
        end_date: endDate ? endDate : "",
        end_time: endTime ? endTime.toTimeString().slice(0, 8) : ""
      };

      onConfirm(null, data, "manual");
    } else if (smartRecommendation) {
      const data = {
        cinema_id,
        rosetta_movie_id,
        concession_ids,
        suggestion_mode: "ALGORITHM",
        start_date: startDate ? startDate : "",
        start_time: startTime ? startTime.toTimeString().slice(0, 8) : "",
        end_date: endDate ? endDate : "",
        end_time: endTime ? endTime.toTimeString().slice(0, 8) : ""
      };

      onConfirm(null, data, "smart");
    }
  };

  useEffect(() => {
    if (!open) {
      setError({
        isError: false,
        message: ""
      });
    }
  }, [open]);

  const parseTime12hToDate = timeStr => {
    if (!timeStr) return null;
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    date.setFullYear(1970, 0, 1);
    return date;
  };

  const convertToISODate = input => {
    const [day, month, year] = input.split("/").map(Number);
    const isoDate = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
    return isoDate;
  };

  const convertDateStringToYYYYMMDD = dateStr => {
    const date = new Date(dateStr);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (open && upsellMode === "edit" && upsellToEdit) {
      setStartDate(
        upsellToEdit.startDate ? convertToISODate(upsellToEdit.startDate) : null
      );
      setEndDate(
        upsellToEdit.endDate ? convertToISODate(upsellToEdit.endDate) : null
      );
      setStartTime(
        upsellToEdit.startTime
          ? parseTime12hToDate(upsellToEdit.startTime)
          : null
      );
      setEndTime(
        upsellToEdit.endTime ? parseTime12hToDate(upsellToEdit.endTime) : null
      );
      setSelectedMovie(upsellToEdit.movie.id);
      setSelectedConcessions(upsellToEdit.concessions.map(c => c.id) || []);
      setCinemasLoading(true);
      cinemasApi.fetchCinemas(jwt).then(res => {
        const fetchedStates = res.data.data;

        setStates(fetchedStates);

        // Find matching state by ID or unique value
        const matchedState = fetchedStates.find(
          s => s.id === upsellToEdit.selectedState.id
        );

        setSelectedState(matchedState || null);
        setSelectedCinema(
          matchedState.cinemas.find(
            c => c.id === upsellToEdit.selectedCinema.id
          ) || matchedState.cinemas[0]
        );
        setCinemasLoading(false);
      });

      if (upsellToEdit.suggestionMode === "MANUAL") {
        setDefineManually(true);
        setSmartRecommendation(false);
      } else if (upsellToEdit.suggestionMode === "ALGORITHM") {
        setSmartRecommendation(true);
        setDefineManually(false);
      }
    } else {
      setCinemasLoading(true);
      cinemasApi.fetchCinemas(jwt).then(res => {
        setStates(res.data.data);
        setSelectedState(res.data.data[0]);
        setSelectedCinema(res.data.data[0].cinemas[0]);
        setCinemasLoading(false);
      });
      setStartDate(null);
      setEndDate(null);
      setStartTime(null);
      setEndTime(null);
      setSelectedMovie(null);
      setSelectedConcessions([]);
      setDefineManually(false);
      setSmartRecommendation(false);
    }
  }, [jwt, open, upsellMode, upsellToEdit]);
  useEffect(() => {}, [jwt, upsellMode, open]);

  useEffect(() => {
    if (startDate && endDate) {
      setLoading(true);
      setError({ isError: false, message: "" });
      movieEntryApi
        .getNewMoviesList(
          `Bearer ${jwt}`,
          selectedCinema.id,
          startDate,
          endDate
        )
        .then(res => {
          const movies = res?.data.data;
          setLoading(false);
          setMoviesData(
            movies?.map((item, index) => ({
              name: item?.movie_name,
              thumbnail: item?.movie_thumbnail,
              poster: item?.movie_poster,
              id: item?.movie_id
            }))
          );
        })
        .catch(e => {
          setError({ isError: true, message: "There is an error" });
          setLoading(false);
        });

      concessionsApi
        .fetchConcessions(`Bearer ${jwt}`, selectedCinema.id)
        .then(res => {
          const allConcessions =
            [].concat.apply(
              [],
              res.data.data?.concessions.map(({ products }) => products)
            ) || [];

          setConcessionsData(
            allConcessions.map(item => ({
              name: item?.product_name,
              image: item?.image_url || emptyConcessions,
              id: item?.product_id
            }))
          );
        })
        .catch(e => {
          setError({ isError: true, message: "There is an error" });
          setLoading(false);
        });
    }
  }, [
    selectedCinema.id,
    endDate,
    jwt,
    startDate,
    upsellToEdit.endDate,
    upsellToEdit.startDate
  ]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="upsell-modal"
    >
      <DialogContent className="upsell-modal-content">
        <DialogTitle className="upsell-modal-title">
          {upsellMode === "edit"
            ? "Edit Product Upsell Mapping"
            : "Set Product Upsell Mapping"}
        </DialogTitle>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <div
              style={{
                display: "block",
                width: "100%"
              }}
            >
              <Grid item xs={6}>
                {cinemasLoading ? (
                  <CircularLoad show={true} />
                ) : (
                  <Grid container spacing={3}>
                    <Grid item xs={5}>
                      <TextField
                        id="select-change-url"
                        select
                        variant="outlined"
                        margin="normal"
                        label="Select state"
                        name="Select-State"
                        value={selectedState}
                        onChange={e => {
                          setSelectedState(e.target.value);
                          setSelectedCinema(e.target.value.cinemas[0]);
                        }}
                        fullWidth
                      >
                        {states.map(item => (
                          <MenuItem key={item?.id} value={item}>
                            {item?.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        id="select-change-url"
                        select
                        variant="outlined"
                        margin="normal"
                        label="Select cinema"
                        name="Select-Cinema"
                        value={selectedCinema}
                        onChange={e => setSelectedCinema(e.target.value)}
                        fullWidth
                      >
                        {selectedState.cinemas &&
                          selectedState?.cinemas.map(item => (
                            <MenuItem key={item?.id} value={item}>
                              {item?.cinema_name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </div>
            <Grid item xs={6}>
              <DatePicker
                autoOk
                clearable
                variant="dialog"
                format="dd/MM/yyyy"
                placeholder="Start Date"
                id="start-date-picker"
                value={startDate !== "" ? startDate : null}
                onChange={date => {
                  if (date instanceof Date && !isNaN(date)) {
                    setStartDate(convertDateStringToYYYYMMDD(date));
                  } else {
                    setStartDate(null);
                  }
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
                inputVariant="outlined"
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <DatePicker
                autoOk
                clearable
                variant="dialog"
                format="dd/MM/yyyy"
                placeholder="End Date"
                id="end-date-picker"
                value={endDate !== "" ? endDate : null}
                onChange={date => {
                  if (date instanceof Date && !isNaN(date)) {
                    setEndDate(convertDateStringToYYYYMMDD(date));
                  } else {
                    setEndDate(null);
                  }
                }}
                minDate={startDate || new Date("1900-01-01")}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
                inputVariant="outlined"
                fullWidth
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>

        <FormControl fullWidth margin="normal">
          <InputLabel>Choose a Movie</InputLabel>
          <Select
            className="upsell-movie-select"
            value={selectedMovie}
            onChange={handleChangeMovie}
            renderValue={selected => {
              const movie = moviesData.find(m => m.id === selected);
              return movie ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%"
                  }}
                >
                  <img
                    src={movie.thumbnail || movie.poster}
                    alt={movie.name}
                    style={{
                      width: 40,
                      height: 60,
                      marginRight: 12,
                      objectFit: "cover"
                    }}
                  />
                  <span style={{ fontWeight: 500 }}>{movie.name}</span>
                </div>
              ) : null;
            }}
          >
            {moviesData.map(movie => (
              <MenuItem key={movie.id} value={movie.id}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={movie.thumbnail || movie.poster}
                    alt={movie.name}
                    style={{
                      width: 40,
                      height: 60,
                      marginRight: 12,
                      objectFit: "cover"
                    }}
                  />
                  <span>{movie.name}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>Select Concession</InputLabel>
          <Select
            multiple
            value={selectedConcessions}
            onChange={handleChangeConcessions}
            renderValue={selected => (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {selected.map(value => {
                  const item = concessionsData.find(c => c.id === value);
                  return (
                    <Chip
                      key={value}
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px"
                          }}
                        >
                          <img
                            src={item?.image || ""}
                            alt={item?.name || ""}
                            style={{
                              width: 30,
                              height: 30,
                              marginRight: 12,
                              objectFit: "cover"
                            }}
                          />
                          <span>{item?.name || ""}</span>
                        </div>
                      }
                    />
                  );
                })}
              </div>
            )}
          >
            {concessionsData.map(item => (
              <MenuItem key={item.id} value={item.id}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{
                      width: 40,
                      height: 60,
                      marginRight: 12,
                      objectFit: "cover"
                    }}
                  />
                  <span>{item.name}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="switch-section">
          <p className="upsell-modal-description">
            Choose Mode for Upsell Suggestions
          </p>
          <FormControlLabel
            control={
              <Switch
                checked={smartRecommendation}
                onChange={e => {
                  const checked = e.target.checked;
                  setSmartRecommendation(checked);
                  if (checked) setDefineManually(false);
                }}
                color="primary"
              />
            }
            label="Smart Recommendation"
          />
          <FormControlLabel
            label="Define upsells manually"
            control={
              <Switch
                checked={defineManually}
                onChange={e => {
                  const checked = e.target.checked;
                  setDefineManually(checked);
                  if (checked) setSmartRecommendation(false);
                }}
                color="primary"
              />
            }
          />
        </div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={6}>
              <TimePicker
                label="Start Time"
                value={startTime}
                onChange={setStartTime}
                fullWidth
                inputVariant="outlined"
              />
            </Grid>

            <Grid item xs={6}>
              <TimePicker
                label="End Time"
                value={endTime}
                onChange={setEndTime}
                fullWidth
                inputVariant="outlined"
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>

        <DialogActions className="upsell-modal-actions">
          <Button onClick={onClose} color="primary" variant="text">
            Close
          </Button>
          <Button
            onClick={upsellMode === "edit" ? handleUpdate : handleCreate}
            color="#616165"
            variant="text"
            disabled={!smartRecommendation && !defineManually}
          >
            {upsellMode === "edit" ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  jwt: state.user.user.jwt
});

export default connect(mapStateToProps)(withRouter(UpsellModal));
